const DATE = {
  SMALL_DATE_FORMAT: 'ddd, MMM Do YYYY',
  TIME_FORMAT: 'HH:mm',
  // MFC2-1416 — format compact date + heure de la dashboard ORDERS, valide avec Diana le 31/08 :
  // « 3-Apr-2026, Tue 21:02 ou Tue 3-Apr-2026, 21:02 ». Le jour de la semaine est conserve pour
  // garder un format universel, reutilisable tel quel pour TRIP ensuite.
  // Par rapport a SMALL_DATE_FORMAT il perd l'ordinal (« 3rd ») et gagne l'heure sur 24 heures.
  // Le fuseau n'est plus repete sur chaque ligne : il est porte par l'intitule de la colonne.
  COMPACT_DATE_TIME_FORMAT: 'ddd D-MMM-YYYY, HH:mm',
}

export default DATE
